import { jsx as _jsx } from "react/jsx-runtime";
import { useDesignTokens } from "../lib/design-tokens";
var Divider = function () {
    var designTokens = useDesignTokens();
    return (_jsx("span", { style: {
            border: "0.5px solid ".concat(designTokens.colors.border.subdued),
        } }));
};
export default Divider;
